/* Pugliando — interazioni leggere (nessuna dipendenza). */

/* Schede prodotti accessibili (pattern WAI-ARIA Tabs, attivazione manuale con frecce). */
if (!customElements.get('pg-tabs')) {
  customElements.define(
    'pg-tabs',
    class PgTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        if (!this.tabs.length) return;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index, true));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        let next = null;
        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        this.select(next, true);
      }

      select(index, focus) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (panel) panel.hidden = !selected;
          if (panel && selected) {
            const grid = panel.querySelector('[data-pg-reveal-stagger]');
            if (grid && window.pgReveal) setTimeout(() => window.pgReveal(grid), 700);
          }
        });
        if (focus) {
          this.tabs[index].focus();
          this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
      }
    }
  );
}

/* Voce "Prodotti" del menu desktop: il testo è un link (porta a tutti i prodotti), il pannello delle
   categorie si apre al passaggio del mouse oppure con il pulsante freccia (clic, tocco, Invio/Spazio).
   Si chiude uscendo con il mouse, con Esc, cliccando fuori o spostando il focus altrove. */
if (!customElements.get('pg-mega')) {
  customElements.define(
    'pg-mega',
    class PgMega extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.pg-mega2__toggle');
        this.panel = this.querySelector('.pg-mega2__panel');
        if (!this.toggle || !this.panel) return;
        this.hover = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.toggle.addEventListener('click', () => this.setOpen(!this.isOpen));
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' || !this.hover.matches) return;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.setOpen(true), 60);
        });
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse' || !this.hover.matches) return;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.setOpen(false), 180);
        });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.setOpen(false);
        });
        this.onKey = (event) => {
          if (event.key !== 'Escape' || !this.isOpen) return;
          this.setOpen(false);
          this.toggle.focus();
        };
        this.onDoc = (event) => {
          if (this.isOpen && !this.contains(event.target)) this.setOpen(false);
        };
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('click', this.onDoc);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('click', this.onDoc);
      }

      get isOpen() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
      }

      setOpen(open) {
        if (open === this.isOpen) return;
        this.toggle.setAttribute('aria-expanded', String(open));
        this.classList.toggle('is-open', open);
        if (open) {
          this.panel.hidden = false;
          requestAnimationFrame(() => this.panel.classList.add('is-visible'));
        } else {
          this.panel.classList.remove('is-visible');
          this.panel.hidden = true;
        }
      }
    }
  );
}

/* Menu mobile: si chiude toccando un link (anche verso un'ancora della stessa pagina) e tornando
   indietro con la cache del browser, così non resta mai aperto sulla pagina successiva. */
(() => {
  const drawer = document.querySelector('header-drawer');
  if (!drawer) return;
  const close = (event) => {
    const details = drawer.querySelector('details');
    if (!details || !details.hasAttribute('open')) return;
    const summary = details.querySelector('summary');
    if (typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event, summary);
    summary?.setAttribute('aria-expanded', 'false');
  };
  drawer.addEventListener('click', (event) => {
    if (event.target.closest('#menu-drawer a[href]')) close(event);
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) close(event);
  });
})();

/* Descrizioni prodotto: evidenzia le intestazioni già presenti nel testo (ingredienti, allergeni...).
   Il contenuto non viene modificato, cambia solo la presentazione. */
(() => {
  const labels = [
    'DENOMINAZIONE PRODOTTO',
    'PROCESSO PRODUTTIVO',
    'INGREDIENTI',
    'ALLERGENI',
    'PESO NETTO',
    'CONSERVAZIONE',
    'VALORI NUTRIZIONALI',
  ];
  document.querySelectorAll('.product__description').forEach((description) => {
    description.querySelectorAll('p').forEach((paragraph) => {
      const text = paragraph.textContent.trim();
      const upper = text.toUpperCase();
      const label = labels.find((item) => upper.startsWith(item));
      if (!label) return;

      if (upper === label || upper === `${label}:`) {
        paragraph.classList.add('pg-desc__label');
        return;
      }

      const previous = paragraph.previousElementSibling;
      if (previous && previous.classList.contains('pg-desc__label') && previous.textContent.trim().toUpperCase().startsWith(label)) return;

      const first = paragraph.firstChild;
      if (first && first.nodeType === Node.TEXT_NODE) {
        const raw = first.textContent;
        const match = raw.match(new RegExp(`^\\s*(${label}\\s*:?)`, 'i'));
        if (!match) return;
        const span = document.createElement('span');
        span.className = 'pg-desc__label';
        span.textContent = match[1].replace(/:$/, '');
        first.textContent = raw.slice(match[0].length).replace(/^\s*:?\s*/, '');
        paragraph.insertBefore(span, first);
        const next = span.nextSibling;
        if (next && next.nodeName === 'BR') next.remove();
      }
    });
  });
})();

/* Barra d'acquisto fissa (mobile e tablet): visibile quando il pulsante principale non è a schermo,
   sia prima di raggiungerlo sia dopo averlo superato. Invia lo stesso modulo del pulsante principale. */
(() => {
  const bar = document.querySelector('[data-pg-sticky-atc]');
  if (!bar) return;
  const main = document.getElementById(bar.dataset.target);
  const trigger = bar.querySelector('[data-pg-sticky-trigger]');
  if (!main || !trigger) return;

  const desktop = window.matchMedia('(min-width: 990px)');
  let mainVisible = true;
  let fallback;

  const update = () => {
    const show = !mainVisible && !desktop.matches;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', String(!show));
    trigger.tabIndex = show ? 0 : -1;
  };

  // Il pulsante principale conta come visibile solo sopra l'altezza della barra
  new IntersectionObserver(
    ([entry]) => {
      mainVisible = entry.isIntersecting;
      update();
    },
    { rootMargin: '0px 0px -88px 0px' }
  ).observe(main);
  desktop.addEventListener('change', update);

  const done = () => {
    clearTimeout(fallback);
    bar.classList.remove('is-loading');
    trigger.removeAttribute('aria-busy');
  };

  trigger.addEventListener('click', () => {
    if (main.disabled || main.getAttribute('aria-disabled') === 'true') {
      main.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    bar.classList.add('is-loading');
    trigger.setAttribute('aria-busy', 'true');
    fallback = setTimeout(done, 8000);
    main.click();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, done);
    subscribe(PUB_SUB_EVENTS.cartError, done);
  }
})();

/* Foto di atmosfera caricate solo quando si avvicinano allo schermo: la foto della hero ha tutta la banda.
   Appena caricata, la foto compare con una breve dissolvenza (vedi .pg-cat__image in pugliando.css). */
(() => {
  const images = document.querySelectorAll('img[data-pg-src]');
  if (!images.length) return;
  const load = (img) => {
    img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
    if (img.dataset.pgSrcset) img.srcset = img.dataset.pgSrcset;
    img.src = img.dataset.pgSrc;
    img.removeAttribute('data-pg-src');
  };
  if (!('IntersectionObserver' in window)) {
    images.forEach(load);
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    },
    { rootMargin: '480px 0px' }
  );
  images.forEach((img) => observer.observe(img));
})();

/* Comparsa morbida allo scorrimento (opacità e leggero spostamento, poche centinaia di millisecondi).
   Gli elementi vengono nascosti solo dopo aver preparato l'osservatore: senza JavaScript o con
   "riduci movimento" tutto resta visibile, e ciò che è già a schermo all'apertura non si anima. */
(() => {
  const root = document.documentElement;
  const singles = Array.from(document.querySelectorAll('[data-pg-reveal], [data-pg-heart]'));
  const groups = Array.from(document.querySelectorAll('[data-pg-reveal-stagger]'));
  const all = singles.concat(groups);
  if (!all.length) return;
  const show = (el) => el.classList.add('is-in');
  if (!root.classList.contains('pg-motion') || !('IntersectionObserver' in window)) {
    all.forEach(show);
    return;
  }

  groups.forEach((group) => {
    Array.from(group.children).forEach((child, index) => child.style.setProperty('--pg-i', String(Math.min(index, 6))));
  });

  const onScreen = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.top < window.innerHeight && rect.bottom > 0;
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
  );

  all.forEach((el) => (onScreen(el) ? show(el) : observer.observe(el)));
  root.classList.add('pg-reveal-ready');
  window.pgReveal = show;
})();

/* Conferma discreta sull'icona del carrello quando si aggiunge un prodotto. */
(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    setTimeout(() => {
      const icon = document.getElementById('cart-icon-bubble');
      const target = icon?.querySelector('.cart-count-bubble') || icon;
      if (!target) return;
      target.classList.remove('pg-bump');
      void target.offsetWidth;
      target.classList.add('pg-bump');
    }, 180);
  });
})();

/* Recensioni Google: chieste al proxy lato server quando la sezione si avvicina allo schermo.
   Il testo delle recensioni entra solo come testo (mai come HTML). Se la richiesta fallisce o non ci sono
   dati, la sezione resta nascosta. Nessun dato viene salvato nel browser. */
if (!customElements.get('pg-reviews')) {
  customElements.define(
    'pg-reviews',
    class PgReviews extends HTMLElement {
      connectedCallback() {
        const target = this.parentElement || this;
        if (!('IntersectionObserver' in window)) {
          this.load();
          return;
        }
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: '900px 0px' }
        );
        this.observer.observe(target);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      async load() {
        try {
          const response = await fetch(this.dataset.endpoint, {
            headers: { Accept: 'application/json' },
            credentials: 'omit',
          });
          if (!response.ok) throw new Error(String(response.status));
          const data = await response.json();
          const reviews = Array.isArray(data?.reviews) ? data.reviews : [];
          if (!reviews.length && typeof data?.rating !== 'number') throw new Error('vuoto');
          this.render(data, reviews.slice(0, Number(this.dataset.max) || 5));
          this.hidden = false;
          if (window.pgReveal) this.querySelectorAll('[data-pg-reveal]').forEach(window.pgReveal);
        } catch (error) {
          this.hidden = true;
        }
      }

      stars(el, rating) {
        el.style.setProperty('--pg-rating', String(Math.max(0, Math.min(5, rating || 0))));
        el.textContent = '★★★★★';
      }

      safeUrl(value) {
        return typeof value === 'string' && value.startsWith('https://') ? value : null;
      }

      render(data, reviews) {
        const nf = new Intl.NumberFormat('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        const ratingEl = this.querySelector('[data-rating]');
        const summaryStars = this.querySelector('.pg-reviews__summary [data-stars]');
        const countEl = this.querySelector('[data-count]');
        if (typeof data.rating === 'number') {
          ratingEl.textContent = nf.format(data.rating);
          this.stars(summaryStars, data.rating);
          ratingEl.setAttribute('aria-label', `${nf.format(data.rating)} su 5`);
        } else {
          this.querySelector('.pg-reviews__score').hidden = true;
        }
        if (Number.isInteger(data.count)) {
          countEl.textContent = data.count === 1 ? '1 recensione' : `${data.count.toLocaleString('it-IT')} recensioni`;
        }
        const all = this.querySelector('[data-all]');
        const write = this.querySelector('[data-write]');
        const allUrl = this.safeUrl(data.reviewsUri) || this.safeUrl(data.mapsUri);
        if (allUrl) {
          all.href = allUrl;
          all.hidden = false;
        }
        if (this.safeUrl(data.writeReviewUri)) {
          write.href = data.writeReviewUri;
          write.hidden = false;
        }

        const list = this.querySelector('[data-list]');
        const template = this.querySelector('[data-template]');
        list.replaceChildren();
        reviews.forEach((review) => {
          const item = template.content.firstElementChild.cloneNode(true);
          this.stars(item.querySelector('[data-stars]'), review.rating);
          item.querySelector('[data-stars-label]').textContent = `${review.rating || 0} stelle su 5`;
          const text = item.querySelector('[data-text]');
          if (review.text) text.textContent = review.text;
          else text.remove();
          const author = item.querySelector('[data-author]');
          author.textContent = review.author || 'Utente Google';
          if (this.safeUrl(review.authorUri)) author.href = review.authorUri;
          else author.removeAttribute('href');
          const avatar = item.querySelector('[data-avatar]');
          if (this.safeUrl(review.authorPhoto)) {
            avatar.src = review.authorPhoto;
            avatar.hidden = false;
          } else {
            avatar.remove();
          }
          item.querySelector('[data-time]').textContent = review.relativeTime || '';
          const link = item.querySelector('[data-review]');
          if (this.safeUrl(review.reviewUri)) link.href = review.reviewUri;
          else link.remove();
          const flag = item.querySelector('[data-flag]');
          if (this.safeUrl(review.flagUri)) flag.href = review.flagUri;
          else flag.remove();
          list.appendChild(item);
        });
      }
    }
  );
}

/* Ordinamento su smartphone: il menu sta fuori dal pannello filtri ma appartiene al suo modulo
   (attributo form); al cambio avvisa il modulo, che aggiorna i prodotti come per i filtri. */
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-pg-sort]');
  if (!select) return;
  const form = document.getElementById(select.getAttribute('form'));
  if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
});

/* Mappa delle consegne: quando entra nello schermo si disegna (classi CSS), poi i pacchi partono da
   Sternatia uno dopo l'altro (animazioni SMIL con begin="indefinite"). Fuori schermo le animazioni
   vanno in pausa. Con "riduci movimento" la mappa resta completa e ferma, senza pacchi. */
if (!customElements.get('pg-italy')) {
  customElements.define(
    'pg-italy',
    class PgItaly extends HTMLElement {
      connectedCallback() {
        this.svg = this.querySelector('svg');
        const motion = document.documentElement.classList.contains('pg-motion');
        if (!this.svg || !motion || !('IntersectionObserver' in window)) {
          this.classList.add('is-in');
          return;
        }
        this.classList.add('is-armed');
        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              if (this.started) this.svg.unpauseAnimations();
              else this.start();
            } else if (this.started) {
              this.svg.pauseAnimations();
            }
          },
          { threshold: 0.2 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      start() {
        this.started = true;
        this.classList.add('is-in');
        const parcels = this.svg.querySelectorAll('.pg-map__parcel');
        const cities = this.svg.querySelectorAll('.pg-map__city');
        parcels.forEach((parcel, i) => {
          // I pacchi partono quando il loro percorso è disegnato (vedi ritardi in pugliando.css)
          const at = 2 + i * 0.32;
          parcel.querySelectorAll('animateMotion, animate').forEach((a) => a.beginElementAt(at));
          cities[i]?.querySelectorAll('animate').forEach((a) => a.beginElementAt(at));
        });
      }
    }
  );
}

/* Video verticale della hero: muto, in loop, senza controlli visibili. Si scarica solo dopo il caricamento
   della pagina e quando la cornice è a schermo, nella versione MP4 più leggera adatta alla sua larghezza:
   fino ad allora resta la copertina (immagine prioritaria, così l'LCP non dipende dal video). Il video
   compare in dissolvenza solo quando suona davvero: se il browser blocca la riproduzione automatica
   (risparmio energetico, dati ridotti) o il file non si carica, resta la copertina. Con "riduci movimento"
   o "risparmio dati" non parte da solo; fuori schermo va in pausa. Il pulsante pausa/riproduci compare
   solo navigando con la tastiera. */
if (!customElements.get('pg-hero-video')) {
  customElements.define(
    'pg-hero-video',
    class PgHeroVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-pg-video-toggle]');
        // data-sources: "larghezza url|larghezza url", dalla più piccola alla più grande
        this.sources = (this.dataset.sources || '')
          .split('|')
          .map((item) => {
            const [width, url] = item.trim().split(' ');
            return { width: Number(width), url };
          })
          .filter((source) => source.width && source.url)
          .sort((a, b) => a.width - b.width);
        if (!this.video || !this.sources.length) return;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = reduce || Boolean(navigator.connection && navigator.connection.saveData);
        if (this.toggle) {
          this.toggle.hidden = false;
          this.toggle.addEventListener('click', () => this.setPaused(!this.paused));
          this.updateToggle();
        }

        const arm = () => {
          if (!('IntersectionObserver' in window)) {
            this.visible = true;
            this.sync();
            return;
          }
          this.observer = new IntersectionObserver(
            ([entry]) => {
              this.visible = entry.isIntersecting;
              this.sync();
            },
            { threshold: 0.25 }
          );
          this.observer.observe(this);
        };
        const idle = (fn) => (window.requestIdleCallback ? requestIdleCallback(fn, { timeout: 2000 }) : setTimeout(fn, 200));
        if (document.readyState === 'complete') idle(arm);
        else window.addEventListener('load', () => idle(arm), { once: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      sync() {
        if (this.paused || !this.visible) {
          if (this.started) this.video.pause();
          return;
        }
        if (!this.started) this.load();
        const playing = this.video.play();
        // Riproduzione automatica bloccata: resta la copertina
        if (playing) playing.catch(() => this.classList.remove('is-playing'));
      }

      load() {
        this.started = true;
        const need = this.clientWidth * Math.min(window.devicePixelRatio || 1, 2) * 0.9;
        const source = this.sources.find((item) => item.width >= need) || this.sources[this.sources.length - 1];
        this.video.muted = true;
        this.video.addEventListener('playing', () => this.classList.add('is-playing'));
        this.video.addEventListener('error', () => this.classList.remove('is-playing'));
        this.video.src = source.url;
      }

      setPaused(paused) {
        this.paused = paused;
        this.updateToggle();
        this.sync();
      }

      updateToggle() {
        if (!this.toggle) return;
        this.toggle.classList.toggle('is-paused', this.paused);
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
      }
    }
  );
}
